import React from 'react';
import { isEmpty } from 'lodash';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import '../../../node_modules/rc-menu/assets/index.css';
import { NavLink } from 'react-router-dom';
import c from '../../config';
import { isExternalURL, parseSanitizedHTML } from '../../utils/Helper';
import HeaderSearch from '../HeaderSearch/HeaderSearch';

const MobileMenu = (props) => {
  const { menu, setIsOpen } = props;

  const onOpenChange = (value) => {
    console.log('onOpenChange', value);
    const subMenus = document.querySelectorAll(
      '.rc-menu-submenu-open:not(.rc-menu-submenu-active)',
    );
    for (let i = 0; subMenus.length > i; i++) {
      subMenus[i].querySelector('.rc-menu-submenu-title').click();
    }
  };

  const generateMenu = (items = []) => {
    const menuItems = [];
    if (items.length > 0) {
      items.map((item, i) => {
        if (item.menu_level_2) {
          menuItems.push(
            <SubMenu key={i} title={parseSanitizedHTML(item.title)}>
              {item.url && linkEle(item)}
              {generateDropDownMenu(item, i)}
            </SubMenu>,
          );
        } else {
          menuItems.push(linkEle(item, `generateMenu${i}`));
        }
        return '';
      });

      menuItems.push(<HeaderSearch isMobileMenu key="mobile_header_search" />);
    }
    return menuItems;
  };

  // Level 2
  const generateDropDownMenu = (item, i) => {
    const result = [];
    let url = '';

    if (item.url) {
      url = linkEle(item, `generateDropDownMenu${i}`);
    } else {
      url = (
        <span className="nav-link active" target="_blank" rel="noopener noreferrer">
          {parseSanitizedHTML(item.title)}
        </span>
      );
    }
    // result.push(<MenuItem>{url}</MenuItem>);
    result.push(generateMenuItems(item.menu_level_2, i));
    return result;
  };

  const linkEle = (item, i) => {
    if (isExternalURL(item.url)) {
      return (
        <MenuItem key={i}>
          <a href={item.url} className="nav-link" target="_blank" rel="noopener noreferrer">
            {parseSanitizedHTML(item.title)}
          </a>
        </MenuItem>
      );
    }

    const to = (location) => {
      const newURL = new URL(window.location.origin + c.routePathTo + item.url);
      return { ...location, pathname: newURL.pathname, search: newURL.search, hash: newURL.hash };
    };

    return (
      <MenuItem key={i}>
        <NavLink
          to={to}
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          {parseSanitizedHTML(item.title)}
        </NavLink>
      </MenuItem>
    );
  };

  const generateMenuItems = (items = [], i) => {
    const url = [];
    let newItems = [];
    if (typeof items !== 'undefined' && items instanceof Array) {
      newItems = items;
    } else {
      newItems.push(items);
    }
    if (newItems.length > 0) {
      newItems.map((item, k) => {
        url.push(linkEle(item, `generateMenuItems${i}-${k}`));
        return '';
      });
    }
    return url;
  };

  let menuDropdown;

  if (!isEmpty(menu)) {
    menuDropdown = generateMenu(menu.menu_level_1);
  }

  return (
    <div>
      <Menu
        mode="inline"
        className="ct-mobileMenu"
        openAnimation="slide-up"
        triggerSubMenuAction="click"
        onOpenChange={onOpenChange}
      >
        {menuDropdown}
      </Menu>
    </div>
  );
};

export default MobileMenu;
